<template>
  <div class="main">
    <sidebarMenu></sidebarMenu>

    <div class="container">
      <h1 class="doc-title">
        Kata
        <small>v0.1</small>
      </h1>

      <div>
        <router-view></router-view>
      </div>
    </div>

    <div class="doc-version">
      <a href="https://github.com/fekata" target="_blank">
        <k-icon type="github-fill" size="20"></k-icon>
        <span>Github</span>
      </a>
    </div>
  </div>
</template>
<script>
import sidebarMenu from "./doc/layout/sidebar-menu.vue";
export default {
  components: { sidebarMenu }
};
</script>

<style lang="less">
@import "../styles/index.less";

html {
  background: #f7f7f7;
}

.doc-version {
  background-color: #fff;
  width: 80px;
  border-left: 1px solid #eaeaea;
  line-height: 80px;
  text-indent: 40px;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  writing-mode: vertical-lr;
  z-index: 10;

  a {
    color: #333;
    text-decoration: none;
    opacity: 0.5;
    .k-icon {
      transform: rotate(450deg);
      vertical-align: 0em;
    }
    span {
      margin-top: 0.2em;
      font-weight: bold;
      color: #999;
    }

    &:hover {
      opacity: 1;
    }
  }
}

.container {
  min-width: 1000px;
  padding: 16px 120px 56px 256px;

  .doc-title {
    text-align: center;
    font-family: "Snell Roundhand", "Courier New";
    text-shadow: -2px 2px 2px #f7f7f7, 0 0px 0px #d0d0d0, -2px 3px 0px #666;
    color: transparent;
    font-size: 56px;
  }

  .page-desc {
    color: #999;
    margin-bottom: 2em;
    font-size: 14px;
  }
}

/** 临时样式 **/
.doc-table {
  border-collapse: collapse;
  border-spacing: 0;
  overflow: auto;
  width: 100%;
  caption {
    text-align: left;
  }
  th {
    font-weight: 600;
  }

  td,
  th {
    border: 1px solid #dfe2e5;
    padding: 6px 13px;
  }
  tr {
    background-color: #fff;
    border-top: 1px solid #c6cbd1;
    &:nth-child(2n) {
      background-color: #f6f8fa;
    }
  }
}
</style>
